"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminContainer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const Admin_1 = require("./Admin");
const admin_context_1 = require("./admin-context");
const AdminContainer = ({ children }) => {
    const { AdminContextProvider, value: AdminContextValue } = (0, admin_context_1.useAdminContextProvider)();
    return ((0, jsx_runtime_1.jsx)(AdminContextProvider, { value: {
            ...AdminContextValue,
            companyPremiumSettings: AdminContextValue.companyPremiumSettings,
            myOffers: AdminContextValue.myOffers,
        }, children: (0, jsx_runtime_1.jsx)(Admin_1.Admin, { children: children }) }));
};
exports.AdminContainer = AdminContainer;
